import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Grid, TableCell, TableRow } from "@mui/material";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import { useAreasContext } from "../../../../../providers/OrganizationAdmin/AreaProvider";
import { useAuth } from "../../../../../hooks";
import ActionDropdown from "../../../../../common/ActionDropdown";
import { icons } from "../../../../../constants";
import { updateArea } from "../../../../../modules/AreaManagement/hooks/AreaHook";
import { Toast } from "../../../../../common/alert";
import { useOrganizationContext } from "../../../../../providers/OrganizationAdmin/OrganizationProvider";
import { updateOrganization } from "../../../../../modules/OrgProf/hook/Organizationhook";
import moment from "moment";

const GAOrgDetailTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
  areaData,
  // handleUpdateAreaStatus,
}) => {
  const { currentUser } = useAuth();
  // const { allAreas, setLoading, handleGetAllAreas } = useAreasContext();
  const { handleGetAllOrganizations, allOrganization, setLoading } =
    useOrganizationContext();

  // console.log("albus", row);
  const [showTableActionDropDown, setShowTableActionDropDown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowTableActionDropDown(false);
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        // component="th"
        id={labelId}
        style={tableTitleFieldStyles}
      >
        {row?.createdAt &&
          moment.unix(row?.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles,
          color:
            row?.status?.status == "reported"
              ? "#CC1F3E"
              : row?.status?.status == "in review"
              ? "#E59A00"
              : row?.status?.status == "resolved"
              ? "#128D1F"
              : "#128D1F",
          textTransform: "capitalize",
        }}
      >
        {row?.status?.status}
      </TableCell>
      {/* <TableCell
        align="left"
        style={{
          ...tableStatusCellStyles,
          minWidth: 170,
          color:
            row?.isActive == true
              ? "#128D1F"
              : row?.isActive == false
              ? "#020303"
              : "#020303",

          textTransform: "capitalize",
        }}
        onClick={() => setShowTableActionDropDown(!showTableActionDropDown)}
      >
        <Grid container>
          {row?.isActive == true ? "Active" : "Inactive"}
          <img
            src={icons.dropdownIcon}
            alt=""
            onClick={() => setShowTableActionDropDown(!showTableActionDropDown)}
            style={{ width: 24, height: 24, marginLeft: "auto" }}
          />
          {showTableActionDropDown && (
            <ActionDropdown
              table={true}
              dropdownRef={dropdownRef}
              options={dropdownOptions}
              handleClick={(isActive) =>
                handleUpdateAreasStatus(isActive, row.id)
              }
            />
          )}
        </Grid>
      </TableCell> */}
      <TableCell align="left" style={tableCellStyles}>
        {row?.status?.action}
      </TableCell>
      <TableCell align="left" style={tableCellStyles}>
        <Grid container>{row?.details}</Grid>
      </TableCell>
    </TableRow>
  );
};

export default GAOrgDetailTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  // paddingLeft: 5,
  // color: "#00A7CD",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
// };
